import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { BedsContainer } from '../../containers/filters/BedsContainer';
import { IFilter } from '../../types/filters';

export const beds: IFilter = {
  availability: isAvailable(FDealType.RentDaily, FOfferType.Any),
  component: BedsContainer,
};
